import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import { toast } from "sonner";

export default function Register() {
  const { t } = useI18n();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", agency_name: "", preferred_language: "fr" });
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm((s) => ({ ...s, [k]: v }));
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("OK");
      navigate("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="flex items-center justify-center p-6 md:p-12 bg-white order-2 md:order-1">
        <div className="w-full max-w-md fade-up">
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">{t("register")}</div>
          <h2 className="font-display text-3xl font-bold tracking-tight mb-2">{t("create_account")}</h2>
          <p className="text-zinc-600 mb-8">{t("signup_subtitle")}</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-zinc-500">{t("agency_name")}</label>
              <input data-testid="reg-agency" required value={form.agency_name} onChange={(e) => set("agency_name", e.target.value)} className="mt-1 w-full border border-zinc-300 px-3 py-2.5 focus:outline-none focus:border-[#002FA7]" style={{borderRadius: 2}}/>
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-zinc-500">{t("email")}</label>
              <input data-testid="reg-email" type="email" required value={form.email} onChange={(e) => set("email", e.target.value)} className="mt-1 w-full border border-zinc-300 px-3 py-2.5 focus:outline-none focus:border-[#002FA7]" style={{borderRadius: 2}}/>
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-zinc-500">{t("password")}</label>
              <input data-testid="reg-password" type="password" required minLength={6} value={form.password} onChange={(e) => set("password", e.target.value)} className="mt-1 w-full border border-zinc-300 px-3 py-2.5 focus:outline-none focus:border-[#002FA7]" style={{borderRadius: 2}}/>
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-zinc-500">{t("preferred_language")}</label>
              <select data-testid="reg-lang" value={form.preferred_language} onChange={(e) => set("preferred_language", e.target.value)} className="mt-1 w-full border border-zinc-300 px-3 py-2.5 bg-white focus:outline-none focus:border-[#002FA7]" style={{borderRadius: 2}}>
                <option value="fr">Français</option>
                <option value="en">English</option>
                <option value="hu">Magyar</option>
                <option value="it">Italiano</option>
                <option value="de">Deutsch</option>
              </select>
            </div>
            <button data-testid="reg-submit" disabled={loading} className="btn-primary w-full" style={{borderRadius: 2}}>
              {loading ? "…" : t("create_account")}
            </button>
          </form>
          <p className="mt-6 text-sm text-zinc-600">
            {t("has_account")} <Link to="/login" data-testid="to-login" className="text-[#002FA7] font-medium underline underline-offset-2">{t("login")}</Link>
          </p>
        </div>
      </div>
      <div className="hidden md:block relative overflow-hidden bg-[#002FA7] order-1 md:order-2">
        <div className="absolute inset-0 opacity-20 grain"/>
        <div className="relative p-12 h-full flex flex-col justify-between text-white">
          <Link to="/" className="font-display font-bold text-xl">RecruitFlow AI</Link>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/70 mb-2">Europe Recruitment</div>
            <h1 className="font-display text-5xl font-bold tracking-tight leading-[0.95] max-w-md">Hire faster, smarter, across borders.</h1>
          </div>
        </div>
      </div>
    </div>
  );
}
